<template>
  <div class="Room">

      <div class="columns" style="flex: 1;">
        <div id="leftCol" class="padding rows flex-space-between scroll-y" v-if="allowedToSpeak" :style="{'left': settingsMenuPos + '%'}">
          <RoomSettings></RoomSettings>
          <div class="screenSmall">
            <hr />
            <button @click="toggleSettings(false)" class="w100">Done!</button>
          </div>

        </div>

        <div id="rightCol">
          <div id="transcriptContainer" class="padding">

            <div class="columns flex-space-between screenLarge scroll-x">
              <TranscriptActions></TranscriptActions>
              <TranscriptSettings></TranscriptSettings>
              <div class="right">
                <label>
                  <span>Use with other services</span>
                </label>
                <button @click="$modal.show('modal-videoCalls')">Video calls</button>
                <button @click="$modal.show('modal-stream')">Live streams</button>
              </div>
            </div>

            <div class="columns screenSmall flex-space-between">
              <button @click="toggleSettings(true)" v-if="allowedToSpeak">Settings</button>
              <h3 v-if="room">Transcript of {{room.data.name}}</h3>
            </div>

            <hr />
            <Transcript ref="transcript" id="transcriptContent"></Transcript>
          </div>
          <div id="bottomRow" class="padding" v-if="allowedToSpeak">
            <div class="columns flex-center">
              <div v-if="speech.data.support">
                <button v-if="!speech.data.running" @click="ttsStart">Start speaking</button>
                <button v-else @click="ttsStop" class="red">Stop speaking</button>
                or
              </div>
              <input type="text" v-model="typedMessage" placeholder="Write message" @keydown.enter="emitTypedMessage"/>
            </div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
// @ is an alias to /src

import RoomSettings from '@/components/RoomSettings.vue'
import Transcript from '@/components/Transcript.vue'
import TranscriptActions from '@/components/TranscriptActions.vue'
import TranscriptSettings from '@/components/TranscriptSettings.vue'

import {addEventListeners, removeEventListeners} from '@/utils.js'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    RoomSettings,
    Transcript,
    TranscriptActions,
    TranscriptSettings,
  },
  data: function () {
    return {
      eventListeners: [],
      typedMessage: "",
      roomNameRoute: "",
      settingsMenuPos: -100
    }
  },
  computed: {
    ...mapState([
      'language'
    ]),
    ...mapState('socket',[
      'id',
      'room'
    ]),
    ...mapState('user',[
      'moods',
      'mood'
    ]),
    ...mapState('speech',[
      'speech'
    ]),
    ...mapGetters('socket',[
      'isAdmin',
      'isDemo'
    ]),
    allowedToSpeak: function () {
      return this.room && (this.isAdmin || this.room.data.mode == "dialogue")
    },
  },
  watch: {
  },
  methods: {
    emitTypedMessage: function () {
      this.emitMessage(this.typedMessage)
      this.typedMessage = ""
    },
    ttsStart: function () {
      this.$store.dispatch('speech/start')
    },
    ttsStop: function () {
      this.$store.dispatch('speech/stop')
    },
    emitMessage: function (message) {
      this.$socket.emit('new user message', message)
    },
    onGetRoom: function (message){
      if(message.room){ //If room already exists, join it
        this.$store.dispatch('socket/joinRoom', {roomName: this.roomNameRoute})
      }
      else{ //If room doesn't exists, go to RoomInit route
        this.$router.push({ name: 'RoomInit', params: {id: this.roomNameRoute}, query: this.$route.query })
      }
    },
    onSelfJoinRoom: function (message){
      this.$store.dispatch('room/setTranscript', {transcript: message.room.data.transcript})
    },
    onUserJoinRoom: function(message){
      message.message = message.user.name + " joined the room"
      message.notice = true
      this.$store.commit('room/addMessage', {message: message})
    },
    onUserMessage: function(message){
      this.$store.dispatch('room/addMessage', {message: message})
    },
    onUserUpdateName: function(message){
      message.message = message.oldName + " changed name to " + message.user.name
      message.notice = true
      this.$store.commit('room/addMessage', {message: message})
    },
    onUserUpdateMood: function(message){
      message.message = message.user.name + " set mood to " + message.user.mood
      message.notice = true
      this.$store.commit('room/addMessage', {message: message})
    },
    onUserLeaveRoom: function(message){
      message.message = message.user.name + " left the room"
      message.notice = true
      this.$store.commit('room/addMessage', {message: message})
    },
    showModal: function () {
      this.$modal.show('modal-zoom');
    },
    setModeFromQuery: function () {
      let mode = this.$route.query.mode
      if(mode){
        if(mode == 'captions'){
          this.$store.commit('room/setTranscriptSettings',{settings: {background: '#000000', color: '#ffffff', size: 30, captionsOnly: true, justify: 'flex-end'}})

        }
      }
    },
    /*fullscreen: function (){
      let el = this.$refs.transcript.$el
      if (el.requestFullscreen) {
        el.requestFullscreen();
      }
      else if (el.mozRequestFullScreen) { //Firefox
        el.mozRequestFullScreen();
      }
      else if (el.webkitRequestFullscreen) { //Chrome, Safari and Opera
        el.webkitRequestFullscreen();
      }
      else if (el.msRequestFullscreen) { // IE/Edge
        el.msRequestFullscreen();
      }
    },*/
    toggleSettings: function (open) {
      this.settingsMenuPos = open ? 0 : -100;
    },
    setEventListeners: function (){
      this.eventListeners = [
        {name: 'socket: get room', func: this.onGetRoom},
        {name: 'socket: self join room', func: this.onSelfJoinRoom},
        {name: 'socket: user join room', func: this.onUserJoinRoom},
        {name: 'socket: new user message', func: this.onUserMessage},
        {name: 'socket: user update name', func: this.onUserUpdateName},
        {name: 'socket: user update mood', func: this.onUserUpdateMood},
        {name: 'socket: user leave room', func: this.onUserLeaveRoom},
        {name: 'speech: result', func: this.emitMessage}
      ]
      addEventListeners(this.$eventBus,this.eventListeners)
    },
    removeEventListeners: function () {
      removeEventListeners(this.$eventBus,this.eventListeners)
    },
  },
  mounted: function () {
    this.roomNameRoute = this.$route.params["id"]
    this.setEventListeners();
    this.$store.dispatch('socket/getRoom', {roomName: this.roomNameRoute})
    this.$store.dispatch('speech/checkSupport')
    this.setModeFromQuery()
  },
  beforeDestroy: function () {
    this.removeEventListeners()
    this.$store.dispatch('socket/leaveRoom', {roomName: this.roomNameRoute})
  }
}
</script>

<style lang="scss" scoped>

  //@import '@/assets/style/screens.scss';

  .Room {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    max-height: 100%;
  }

  .columns{
    overflow: hidden;
  }

  #leftCol, #bottomRow{
    background: var(--color1);
  }

  #leftCol {
    flex: 1 0 200px;
    display: flex;
    flex-direction: column;
    border-right: var(--border);
  }

  #rightCol{
    flex: 1 1 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  #transcriptContainer{
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  #bottomRow{
    font-family: var(--font-header);
    border-top: var(--border);
  }

  #bottomRow .columns{
    flex-wrap: wrap;
  }

  #bottomRow input{
    flex: 1;
  }

  @media screen and (max-width: $screenSmall) {

    #leftCol {
      position: absolute;
      top:0;
      width: 100%;
      height: 100%;
      transition: left 1s;
      z-index: 1;
      box-sizing: border-box;
      border: 0;
    }
  }

</style>
